import { useAppOptions, useBooking } from 'hooks';

const useSteadyMDDepartmentId = (): number | null => {
    const appOptions = useAppOptions();
    const { booking } = useBooking();

    if (appOptions.type === 'main') {
        return booking.department?.hubspot?.steady_md_dept_id ?? null;
    }

    if ('steadyMDDeptId' in appOptions && appOptions.steadyMDDeptId && appOptions.steadyMDDeptId > 0) {
        return appOptions.steadyMDDeptId;
    } else {
        return null;
    }
};

export { useSteadyMDDepartmentId };
